import React from "react";

const Footer = (props) => {
  const product = props.product
  return (
    <React.Fragment>
      <div className="row">
        <div className="col p-0">
          <img src={process.env.PUBLIC_URL + "/img/products/" + product.bgFooter} alt="Campo" className="w-100 d-none d-md-block" />
          <img src={process.env.PUBLIC_URL + "/img/products/" + product.bgFooterMobile} alt="Campo" className="img-fluid d-md-none" />
        </div>
      </div>
      <div className="row bg-green pt-3">
        <div className="col text-center">
          <p className="text-white">&copy; Tecnomyl</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
